module.exports = __webpack_public_path__ + "img/invite-admin-members.ababb0a2.webp";